(function () {
  var STORAGE_KEY = 'selen_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(ids) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    updateWishlistCount();
  }

  function updateWishlistCount() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-selen-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function syncButtonState(button) {
    var id = button.getAttribute('data-product-id');
    var active = getWishlist().indexOf(id) !== -1;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function toggleWishlist(button) {
    var id = button.getAttribute('data-product-id');
    var ids = getWishlist();
    var index = ids.indexOf(id);
    if (index === -1) {
      ids.push(id);
    } else {
      ids.splice(index, 1);
    }
    setWishlist(ids);
    document.querySelectorAll('.selen-wishlist-btn[data-product-id="' + id + '"]').forEach(syncButtonState);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.selen-wishlist-btn');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    toggleWishlist(button);
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.selen-wishlist-btn').forEach(syncButtonState);
    updateWishlistCount();
  });

  if (document.readyState !== 'loading') {
    document.querySelectorAll('.selen-wishlist-btn').forEach(syncButtonState);
    updateWishlistCount();
  }
})();
